import { useBillingServiceStore } from '@billing/AppProvider'
import { Asterisk } from '@billing/components/asterisk/Asterisk'
import { CustomerAutocomplete } from '@billing/components/CustomerAutocomplete'
import { Box, Stack, Typography } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

export const HandlingPreBillingReportFilter = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { handlingServicesPrebillingUIStore, reportsUIStore, companyStore } =
    useBillingServiceStore()
  const localFormat = dayjs.Ls[dayjs.locale()].formats.L

  useEffect(() => {
    async function fetchData() {
      await companyStore.load()
    }

    fetchData()
  }, [companyStore])

  const customerInputHasError =
    reportsUIStore.nextButtonWasBlocked && !handlingServicesPrebillingUIStore.customerId

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }} gap={theme.customSpacing.m}>
      <CustomerAutocomplete
        selectedValue={handlingServicesPrebillingUIStore.customerId}
        options={handlingServicesPrebillingUIStore.customerOptions}
        hasError={customerInputHasError}
        onChange={(value: string) => {
          handlingServicesPrebillingUIStore.setCustomerId(value)
        }}
      />

      <Stack gap={theme.customSpacing.xs}>
        <Typography variant='subtitle2'>
          {t('period', 'Period')} {Asterisk}
        </Typography>
        <Stack
          gap={theme.customSpacing.m}
          sx={{
            [theme.breakpoints.up('sm')]: {
              flexDirection: 'row',
            },
          }}
        >
          <MobileDatePicker
            label={t('from', 'From')}
            value={handlingServicesPrebillingUIStore.from}
            onChange={newValue => handlingServicesPrebillingUIStore.setFrom(dayjs(newValue))}
            disableFuture={true}
            maxDate={handlingServicesPrebillingUIStore.to}
            slotProps={{
              actionBar: {
                actions: ['clear', 'accept', 'today'],
              },
              textField: {
                required: true,
                error:
                  reportsUIStore.nextButtonWasBlocked && !handlingServicesPrebillingUIStore.from
                    ? true
                    : undefined,
                helperText: localFormat,
              },
            }}
            sx={{
              width: '100%',
              [theme.breakpoints.up('sm')]: {
                width: '268px',
              },
            }}
          />
          <MobileDatePicker
            label={t('to', 'To')}
            value={handlingServicesPrebillingUIStore.to}
            onChange={newValue => handlingServicesPrebillingUIStore.setTo(dayjs(newValue))}
            disableFuture={true}
            minDate={handlingServicesPrebillingUIStore.from}
            slotProps={{
              actionBar: {
                actions: ['clear', 'accept', 'today'],
              },
              textField: {
                required: true,
                error:
                  reportsUIStore.nextButtonWasBlocked && !handlingServicesPrebillingUIStore.to
                    ? true
                    : undefined,
                helperText: localFormat,
              },
            }}
            sx={{
              width: '100%',
              [theme.breakpoints.up('sm')]: {
                width: '268px',
              },
            }}
          />
        </Stack>
      </Stack>
    </Box>
  )
})
